export function deepClone<T>(data: T): T {
  if (typeof data !== 'object' || data === null) {
    return data;
  }

  if (typeof structuredClone === 'function') {
    return structuredClone(data);
  }

  return JSON.parse(JSON.stringify(data)) as T;
}
